@if (page$ | async; as page) {
  <div class="main">
    @if (filter$ | async; as filter) {
        <div class="filter-toolbar">
          <tnb-erzeugungsanlage-filter
            (filter)="filterChanged($event)"
            [initialFilter]="filter"
          ></tnb-erzeugungsanlage-filter>
        </div>
        <div class="view-mode-switch-toolbar">
          @if (this.authService.isNvnb(this.profile)) {
            <div class="confirm-up-to-date">
              <button (click)="confirmUpToDateness()"
                      [disabled]="recentlyConfirmed || islastChangedNotUptoDate()"
                      data-qa="button-ez-confirmUpToDateness"
                      matButton="filled"
              >
                  <mat-icon svgIcon="innogy_picto_check"></mat-icon>
                  Datenaktualität bestätigen
              </button>
              <mat-icon [matTooltip]="lastChangedDateTooltipText"
                        matTooltipClass="multiline-tooltip"
                        matTooltipPosition="right"
                        svgIcon="innogy_picto_speech-bubble_exclamationmark"
                        aria-hidden="false"
                        [attr.aria-label]="lastChangedDateTooltipText"
              >
              </mat-icon>
            </div>
          }
          <div>
            <mat-button-toggle-group (change)="toggleViewMode($event)" [(ngModel)]="viewMode">
              <mat-button-toggle data-qa="grid-view"
                value="grid">
                <mat-icon>view_module</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle data-qa="table-view"
                value="table">
                <mat-icon>view_headline</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        @if (erzeugungsanlagenPage$ | async; as erzeugungsanlagenPage) {
          <div
            data-qa="erzeugungsanlage-result">
            @if (viewMode === VIEW_GRID) {
              <tnb-erzeugungsanlage-tile-view
              [erzeugungsanlagen]="erzeugungsanlagenPage.content"></tnb-erzeugungsanlage-tile-view>
            }
            @if (viewMode === VIEW_TABLE) {
              <tnb-erzeugungsanlage-table (sortChange)="sortChange($event)"
                [erzeugungsanlagen]="erzeugungsanlagenPage.content"
                [netzbetreiberType]="profile.netzbetreiberType"
                [sortActive]="page.sort"
                [sortDirection]="page.direction"
                >
              </tnb-erzeugungsanlage-table>
            }
            <mat-paginator #paginator
              (page)="pageChange($event)"
              [hidePageSize]="true"
              [length]="erzeugungsanlagenPage.totalElements"
              [pageIndex]="page.page"
              [pageSize]="PAGE_SIZE"
              [showFirstLastButtons]="false"
              >
            </mat-paginator>
          </div>
        }
    }
  </div>
}
